export default __webpack_public_path__ + "static/media/depend.0d377ace.png";